document.addEventListener("DOMContentLoaded", () => {
  // 购物车总价选择器（已是当前国家/货币换算后的展示价格）
  var $CartPrice = $(".totals__total-value .money");

  // 幸运抽奖模块元素
  var $luckyModule = $(".lucky-module");
  if (!$luckyModule.length) return;

  var $progressFill = $luckyModule.find(".lucky-progress__fill");
  var $progressLabelStart = $luckyModule.find(".lucky-progress__label-start");
  var $progressLabelEnd = $luckyModule.find(".lucky-progress__label-end");
  var $awayAmount = $luckyModule.find(".lucky-note__away-amount");
  var $qualifiedText = $luckyModule.find(".lucky-note__qualified");
  var $unqualifiedText = $luckyModule.find(".lucky-note__unqualified");
  var $learnMoreBtn = $luckyModule.find(".lucky-card--draw .lucky-card__btn");
  var $notePopup = $luckyModule.find(".lucky-note");

  // 满赠门槛金额（美元基准），从 data 属性读取
  var THRESHOLD_USD = Number($luckyModule.data("threshold")) || 500;

  // 支持的货币及对应符号
  var SUPPORTED_CURRENCIES = ["USD", "GBP", "EUR", "CAD", "AUD"];
  var CURRENCY_SYMBOLS = {
    USD: "$",
    GBP: "£",
    EUR: "€",
    CAD: "$",
    AUD: "$",
  };

  // 获取当前 Shopify 货币信息，不支持的货币按 USD 处理
  function getCurrencyInfo() {
    var active = "USD";
    var rate = 1;

    if (typeof Shopify !== "undefined" && Shopify.currency) {
      var shopifyActive = Shopify.currency.active;
      var shopifyRate = Number(Shopify.currency.rate);

      if (SUPPORTED_CURRENCIES.indexOf(shopifyActive) !== -1 && shopifyRate > 0) {
        active = shopifyActive;
        rate = shopifyRate;
      }
    }

    return {
      active: active,
      rate: rate,
      symbol: CURRENCY_SYMBOLS[active],
    };
  }

  // 格式化金额：有小数保留两位，整数不显示小数
  function formatPrice(amount, symbol) {
    var fixed = Number(amount).toFixed(2);
    var formatted = fixed.endsWith(".00") ? fixed.slice(0, -3) : fixed;
    return symbol + formatted;
  }

  var bundlerDiscountedCents = null;

  // 获取当前购物车总价文本（无 bundle 折扣时使用）
  function getNowPriceText() {
    var $total = $(".totals__total-value");
    var totalPrice = "";

    if ($total.hasClass("bundler-cart-price-info-container")) {
      totalPrice = $total.find(".bndlr-cart-discounted-value").text();
    } else if ($total.find(".money").length > 1) {
      totalPrice = $CartPrice.text();
    } else {
      totalPrice = $total.text();
    }

    return totalPrice;
  }

  function getCartPriceNumber() {
    if (bundlerDiscountedCents != null) {
      return Number((bundlerDiscountedCents / 100).toFixed(2));
    }

    return parsePriceNumber(getNowPriceText());
  }

  // 将展示价格文本转为数字（已是当前货币金额，保留两位小数）
  function parsePriceNumber(priceText) {
    return Number((Number(String(priceText).replace(/[^0-9]/g, "")) / 100).toFixed(2));
  }

  // 将美元门槛换算为当前国家/货币门槛
  function getLocalThreshold(rate) {
    return Number((THRESHOLD_USD * rate).toFixed(2));
  }

  // 更新进度条两端文案（$0 与门槛金额，门槛文案向上取整展示）
  function updateProgressLabels(currencyInfo, localThreshold) {
    $progressLabelStart.text(formatPrice(0, currencyInfo.symbol));
    $progressLabelEnd.text(formatPrice(Math.ceil(localThreshold), currencyInfo.symbol));
  }

  // 更新进度条宽度
  function updateProgressBar(cartPrice, localThreshold) {
    var progress = localThreshold > 0 ? Math.min((cartPrice / localThreshold) * 100, 100) : 0;
    $progressFill.css("width", progress + "%");
  }

  // 更新 note 弹层中的差价文案
  function updateNoteMessage(cartPrice, localThreshold, currencyInfo) {
    if (cartPrice >= localThreshold) {
      $qualifiedText.show();
      $unqualifiedText.hide();
      return;
    }

    var remaining = Number((localThreshold - cartPrice).toFixed(2));
    $awayAmount.text(formatPrice(remaining, currencyInfo.symbol));
    $qualifiedText.hide();
    $unqualifiedText.show();
  }

  // 根据购物车金额更新进度条和 note 文案
  function updateLuckyState(cartPrice, currencyInfo, localThreshold) {
    updateProgressLabels(currencyInfo, localThreshold);
    updateProgressBar(cartPrice, localThreshold);
    updateNoteMessage(cartPrice, localThreshold, currencyInfo);
  }

  // 读取购物车价格并刷新 UI
  function priceJudgment() {
    var currencyInfo = getCurrencyInfo();
    var localThreshold = getLocalThreshold(currencyInfo.rate);
    var cartPrice = getCartPriceNumber();

    updateLuckyState(cartPrice, currencyInfo, localThreshold);
  }

  document.addEventListener("bundler:total_cart_values", function (e) {
    var detail = e.detail || {};
    var discountAmount = Number(detail.discount_amount) || 0;

    if (discountAmount > 0 && detail.total_amount_discounted != null) {
      bundlerDiscountedCents = detail.total_amount_discounted;
    } else {
      bundlerDiscountedCents = null;
    }

    priceJudgment();
  });

  // 监听购物车总价变化
  var cartIconBubble = document.querySelector("#cart-icon-bubble");
  if (cartIconBubble) {
    var cartPriceObserver = new MutationObserver(function () {
      if (!$(".bndlr-cart-discounted-value").length) {
        bundlerDiscountedCents = null;
      }
      priceJudgment();
    });

    cartPriceObserver.observe(cartIconBubble, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  // 初始化进度条和 note 文案
  priceJudgment();

  // LEARN MORE 按钮点击显示/隐藏 note 弹层
  $learnMoreBtn.on("click", function (event) {
    event.preventDefault();
    $notePopup.toggleClass("is-visible");
    $(this).attr("aria-expanded", $notePopup.hasClass("is-visible"));
  });

  // 社媒分享卡片内所有链接新窗口打开
  $luckyModule.find(".lucky-card--share a").attr("target", "_blank").attr("rel", "noopener noreferrer");

  // 点击 note 外部区域关闭弹层
  $(document).on("click", function (event) {
    if (
      $notePopup.hasClass("is-visible") &&
      !$(event.target).closest(".lucky-note, .lucky-card--draw .lucky-card__btn").length
    ) {
      $notePopup.removeClass("is-visible");
    }
  });
});
